var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ error: _vm.hasErrors }},[_vm._t("default"),(_vm.hasErrors)?_c('div',{staticClass:"errors"},[_c('p',{class:['error' ].concat( _vm.errorClasses)},[_vm._v(" "+_vm._s(_vm.activeErrorMessagesModified[0])+" ")])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }